/**
 * Wizard initRoot body, extracted from workshop-booking-wizard.js.
 * Receives IIFE scope as S. Loaded (defer) before workshop-booking-wizard.js.
 * Live → venue → datetime → variants attach after state exists (same S bag).
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlow) return;
  global.WorkshopBookingWizardFlow = {
    attach: function (S) {
      if (!S) return;
      var wizardRoot = S.wizardRoot;
      var Flow = S.Flow;
      var LiveApi = S.LiveApi;
      var WizardLive = S.WizardLive;
      var WBWUtils = S.WBWUtils;
      var MONTHS = S.MONTHS;
      var DOW_PICKER = S.DOW_PICKER;
      var DOW_MED = S.DOW_MED;
      var DOW_SHORT = S.DOW_SHORT;
      var VARIANT_ROW_MIN_PX = S.VARIANT_ROW_MIN_PX;
      var VARIANT_ROW_MIN_H_PX = S.VARIANT_ROW_MIN_H_PX;
      var VARIANT_GRID_GAP_PX = S.VARIANT_GRID_GAP_PX;
      var getLiveApi = S.getLiveApi;
      var getWizardLive = S.getWizardLive;
      var parseData = S.parseData;
      var WB_WORKSHOP_TYPES = S.WB_WORKSHOP_TYPES;
      var workshopTypeFromText = S.workshopTypeFromText;
      var fetchWorkshopTypeFromProduct = S.fetchWorkshopTypeFromProduct;
      var resolveWaitlistWorkshopType = S.resolveWaitlistWorkshopType;
      var parseSiblingPromoData = S.parseSiblingPromoData;
      var siblingPromoScope = S.siblingPromoScope;
      var attachSiblingPromoHost = S.attachSiblingPromoHost;
      var ensureSiblingPromoDom = S.ensureSiblingPromoDom;
      var siblingPromoHosts = S.siblingPromoHosts;
      var WB_HANDLE_ALIAS_GROUPS = S.WB_HANDLE_ALIAS_GROUPS;
      var handlesMatchForPromo = S.handlesMatchForPromo;
      var canonicalPromoHandle = S.canonicalPromoHandle;
      var normalizeTimeLabel = S.normalizeTimeLabel;
      var parseTimeLabelParts = S.parseTimeLabelParts;
      var formatHourMinuteMeridiem = S.formatHourMinuteMeridiem;
      var timePartsToMinutes = S.timePartsToMinutes;
      var formatSessionTimeRange = S.formatSessionTimeRange;
      var buildPromoVenueContext = S.buildPromoVenueContext;
      var venueRowMatchesContextScore = S.venueRowMatchesContextScore;
      var resolvePromoDeepLinkFromIndex = S.resolvePromoDeepLinkFromIndex;
      var WB_SIBLING_HANDLE_FALLBACKS = S.WB_SIBLING_HANDLE_FALLBACKS;
      var WB_SIBLING_LABELS = S.WB_SIBLING_LABELS;
      var parseVenueWaitlistCatalog = S.parseVenueWaitlistCatalog;
      var findCatalogVenueByToken = S.findCatalogVenueByToken;
      var parseVenueWorkshopIndex = S.parseVenueWorkshopIndex;
      var findIndexRowByEventId = S.findIndexRowByEventId;
      var promoEventIdMatchesVenueContext = S.promoEventIdMatchesVenueContext;
      var resolveVenueAnchoredPromoEventId = S.resolveVenueAnchoredPromoEventId;
      var resolveEventIdForProductAtVenue = S.resolveEventIdForProductAtVenue;
      var slotListContainsEventId = S.slotListContainsEventId;
      var resolveSiblingEventIdFromSessionAnchor = S.resolveSiblingEventIdFromSessionAnchor;
      var venueRefAliasKeys = S.venueRefAliasKeys;
      var venueNameLookupKey = S.venueNameLookupKey;
      var buildVenueWorkshopMaps = S.buildVenueWorkshopMaps;
      var normalizeVenueRefId = S.normalizeVenueRefId;
      var ensureSiblingWorkshops = S.ensureSiblingWorkshops;
      var collectAlsoAvailableHandles = S.collectAlsoAvailableHandles;
      var escapeHtml = S.escapeHtml;
      var extractNumericEventIdForUrl = S.extractNumericEventIdForUrl;
      var extractNumericVariantIdForUrl = S.extractNumericVariantIdForUrl;
      var extractNumericVenueRefForUrl = S.extractNumericVenueRefForUrl;
      var extractEventIdFromUrl = S.extractEventIdFromUrl;
      var extractPromoEventIdFromProduct = S.extractPromoEventIdFromProduct;
      var refsOverlap = S.refsOverlap;
      var venueNamesLooselyMatch = S.venueNamesLooselyMatch;
      var venueMatchesIndexRow = S.venueMatchesIndexRow;
      var readInitialVariantIdFromUrl = S.readInitialVariantIdFromUrl;
      var getEventIdFromUrl = S.getEventIdFromUrl;
      var getVenueTokenFromUrl = S.getVenueTokenFromUrl;
      var getStateCodeFromUrl = S.getStateCodeFromUrl;
      var urlHasWizardDeepLink = S.urlHasWizardDeepLink;
      var venueCardIsWaitlistOnly = S.venueCardIsWaitlistOnly;
      var getWbwStepFromUrl = S.getWbwStepFromUrl;
      var clearWbwStepFromUrl = S.clearWbwStepFromUrl;
      var isVenueHandleToken = S.isVenueHandleToken;
      var venueUrlToken = S.venueUrlToken;
      var venueHandleFromSlotRaw = S.venueHandleFromSlotRaw;
      var venueMatchesUrlToken = S.venueMatchesUrlToken;
      var updateWizardBookingUrl = S.updateWizardBookingUrl;
      var formatMoney = S.formatMoney;
      var slotBookable = S.slotBookable;
      var slotStatus = S.slotStatus;
      var slotDisplayStatus = S.slotDisplayStatus;
      var slotHidden = S.slotHidden;
      var slotSoldOut = S.slotSoldOut;
      var slotVisible = S.slotVisible;
      var formatSlotOptionText = S.formatSlotOptionText;
      var slotDateKey = S.slotDateKey;
      var padDatePart = S.padDatePart;
      var toIsoDateKey = S.toIsoDateKey;
      var timeLabelFromDateTime = S.timeLabelFromDateTime;
      var normalizeEventToSlot = S.normalizeEventToSlot;
      var eventsToSlots = S.eventsToSlots;
      var buildDaysMap = S.buildDaysMap;
      var wizardViewportWidth = S.wizardViewportWidth;
      var calendarDowLabels = S.calendarDowLabels;
      var calDateKey = S.calDateKey;
      var formatCalDateBtn = S.formatCalDateBtn;
      var formatBookingSubLabel = S.formatBookingSubLabel;
      var isStoreVenue = S.isStoreVenue;
      var formatPopupDateLabel = S.formatPopupDateLabel;
      var vQtyKey = S.vQtyKey;
      var normalizeOptionValue = S.normalizeOptionValue;
      var styleValueFromVariant = S.styleValueFromVariant;
      var getSectionRoot = S.getSectionRoot;
      var isSessionOptionHandle = S.isSessionOptionHandle;
      var parseVariantsJson = S.parseVariantsJson;
      var ensureVariantMediaMeta = S.ensureVariantMediaMeta;
      var findShopifyVariantByWizard = S.findShopifyVariantByWizard;
      var findStyleFieldset = S.findStyleFieldset;
      var getProductContainer = S.getProductContainer;
      var goToImpulseVariantMedia = S.goToImpulseVariantMedia;
      var parseZoomThumbMediaId = S.parseZoomThumbMediaId;
      var parseZoomSlideMediaId = S.parseZoomSlideMediaId;
      var goToZoomGalleryByMediaId = S.goToZoomGalleryByMediaId;
      var findImpulseMediaSlide = S.findImpulseMediaSlide;
      var resolveImpulseMediaZoomPosition = S.resolveImpulseMediaZoomPosition;
      var raiseImpulseProductModal = S.raiseImpulseProductModal;
      var openImpulseProductZoom = S.openImpulseProductZoom;
      var closeImpulseProductZoom = S.closeImpulseProductZoom;
      var openWizardVariantImageFallback = S.openWizardVariantImageFallback;
      var syncImpulseStyleOption = S.syncImpulseStyleOption;
      var syncImpulseOptionsByVariant = S.syncImpulseOptionsByVariant;
      var syncImpulseMasterVariantId = S.syncImpulseMasterVariantId;
      var syncVariantToPdp = S.syncVariantToPdp;
      var timeDdPortalEl = S.timeDdPortalEl;
      var cleanupOrphanTimeDdPanels = S.cleanupOrphanTimeDdPanels;
      var ensureTimeDdPortal = S.ensureTimeDdPortal;
      var getCalTimeDdParts = S.getCalTimeDdParts;
      var positionTimeDdPanel = S.positionTimeDdPanel;
      var resetTimeDdPanelStyle = S.resetTimeDdPanelStyle;
      var bindTimeDdReposition = S.bindTimeDdReposition;
      var wbwEmitVenueReset = S.wbwEmitVenueReset;
      var bindWizardSearchLayout = S.bindWizardSearchLayout;
      var venueHasBookableEvents = S.venueHasBookableEvents;
      var venueHasVisibleEvents = S.venueHasVisibleEvents;
      var venueIsWaitlistOnly = S.venueIsWaitlistOnly;
      var variantCardLayout = S.variantCardLayout;
      var wbwAddonDisplayTitle = S.wbwAddonDisplayTitle;
      var isMobileViewport = S.isMobileViewport;
      var isDesktopViewport = S.isDesktopViewport;
      var variantGridColsCap = S.variantGridColsCap;
      var pickStackedGridColumns = S.pickStackedGridColumns;
      var variantGridGapPx = S.variantGridGapPx;
      var stackedThumbPx = S.stackedThumbPx;
      var pickVariantGridColumns = S.pickVariantGridColumns;
      var easeOutCubic = S.easeOutCubic;
      var carouselSlideScrollLeft = S.carouselSlideScrollLeft;
      var pinCarouselToRow = S.pinCarouselToRow;
      var animateCarouselScrollLeft = S.animateCarouselScrollLeft;
      var syncVariantCarouselNav = S.syncVariantCarouselNav;
      var applyVariantCarouselLayout = S.applyVariantCarouselLayout;
      var clearVariantCarouselLayout = S.clearVariantCarouselLayout;
      var prepareVariantCarouselMount = S.prepareVariantCarouselMount;
      var getCarouselOffset = S.getCarouselOffset;
      var setCarouselOffset = S.setCarouselOffset;
      var applyVariantGridLayout = S.applyVariantGridLayout;
      var bindVariantGridResize = S.bindVariantGridResize;
      var variantQtyControlHtml = S.variantQtyControlHtml;
      var splitFullName = S.splitFullName;
    if (!wizardRoot || wizardRoot.__wbwBound) return;
    cleanupOrphanTimeDdPanels();

    var data = parseData(wizardRoot);
    if (!data) return;
    /* Mark bound only after JSON parse — otherwise a bad WorkshopWizardData
       leaves venues with no click handler and blocks all future inits. */
    wizardRoot.__wbwBound = true;

    var sectionId = data.sectionId || wizardRoot.getAttribute('data-section-id') || '';
    var venueWorkshopIndexRows = parseVenueWorkshopIndex(sectionId);
    var venueWorkshopMaps = buildVenueWorkshopMaps(venueWorkshopIndexRows);
    var venueWorkshopMap = venueWorkshopMaps.byRef;
    var venueWorkshopMapByName = venueWorkshopMaps.byName;
    var siblingPromoData = parseSiblingPromoData(sectionId);
    var siblingWorkshops = ensureSiblingWorkshops(
      siblingPromoData && Array.isArray(siblingPromoData.siblingWorkshops)
        ? siblingPromoData.siblingWorkshops
        : [],
      data.productHandle || wizardRoot.getAttribute('data-product-handle')
    );
    var workshopCatalog =
      siblingPromoData && Array.isArray(siblingPromoData.workshopCatalog)
        ? siblingPromoData.workshopCatalog
        : [];
    var promoCatalogByHandle = new Map();
    function indexPromoCatalog(entry) {
      if (!entry || !entry.handle) return;
      var h = String(entry.handle).trim().toLowerCase();
      if (!h) return;
      var prev = promoCatalogByHandle.get(h) || {};
      promoCatalogByHandle.set(h, {
        handle: h,
        title: String(entry.title || entry.label || prev.title || h).trim(),
        url: String(entry.url || prev.url || '/products/' + encodeURIComponent(h)).trim(),
        image: entry.image || prev.image || '',
      });
    }
    siblingWorkshops.forEach(indexPromoCatalog);
    workshopCatalog.forEach(indexPromoCatalog);
    var siblingPromoEyebrow = String(
      (siblingPromoData && siblingPromoData.siblingPromoEyebrow) || 'Also available as'
    ).trim();
    ensureSiblingPromoDom(wizardRoot, sectionId);

    var variants = Array.isArray(data.variants) ? data.variants.slice() : [];
    var addonVariantIdKey = (function () {
      if (wizardRoot.getAttribute('data-addon-enabled') !== 'true') return '';
      var raw = wizardRoot.getAttribute('data-addon-variant-id');
      return raw ? vQtyKey(raw) : '';
    })();

    function addonVariantObject() {
      if (!addonVariantIdKey) return null;
      var cents = parseInt(wizardRoot.getAttribute('data-addon-price-cents') || '0', 10);
      if (!Number.isFinite(cents)) cents = 0;
      return {
        id: addonVariantIdKey,
        label: wbwAddonDisplayTitle(wizardRoot),
        title: wbwAddonDisplayTitle(wizardRoot),
        price: cents,
        image_url: String(wizardRoot.getAttribute('data-addon-image') || '').trim(),
        _isAddon: true,
      };
    }

    function isAddonVariantId(id) {
      return !!addonVariantIdKey && vQtyKey(id) === addonVariantIdKey;
    }

    var bookingRoot = wizardRoot.querySelector('.pdp-workshop-booking');
    var eventsRoot = bookingRoot ? bookingRoot.querySelector('[data-workshop-events]') : null;
    var venueWaitlistCatalog = parseVenueWaitlistCatalog(bookingRoot);
    var productId = String(data.productId || wizardRoot.getAttribute('data-product-id') || '');

    var state = {
      branch: 'venue',
      flow: 'booking',
      selectedVenueCard: null,
      selectedVenue: null,
      venueDisplayLabel: '',
      slotList: [],
      daysWithEvents: {},
      viewMonth: new Date(),
      selectedDate: '',
      selectedSlot: null,
      variantQty: {},
      variantWhen: {},
      lbEditVariant: '',
      lbApplyAll: null,
      lbAskApply: false,
      focusedVariantId: '',
      lockedVariantId: readInitialVariantIdFromUrl(),
      sessionByVenue: {},
    };
    var liveHelper = getWizardLive();
    var liveController =
      liveHelper && typeof liveHelper.createController === 'function'
        ? liveHelper.createController(wizardRoot, {
            productHandle: data.productHandle || wizardRoot.getAttribute('data-product-handle') || '',
          })
        : null;

    var ALL_STEPS = ['venue', 'waitlist', 'datetime', 'variants'];

    var liveFlags = { atcInFlight: false, syncingWhen: false };
    var liveRuntime = {
      pollStarted: false,
      monthSweepTimer: 0,
      liveStream: null,
      liveStreamOk: false,
      streamLifecycleBound: false,
      pendingPushWhileHidden: false,
      lastLiveApplyAt: 0,
      lastLiveBatchAsOf: 0,
      pushRefreshTimer: 0,
      liveFollowupTimer: 0,
    };

    function resolveVenueHandleForUrl() {
      var t = venueUrlToken(state.selectedVenue);
      if (t) return t;
      t = venueHandleFromSlotRaw(state.selectedSlot && state.selectedSlot._raw);
      if (t) return t;
      if (state.selectedVenueCard) {
        var ref = String(state.selectedVenueCard.getAttribute('data-venue-ref-id') || '').trim();
        t = extractNumericVenueRefForUrl(ref) || ref;
        if (t) return t;
      }
      return '';
    }

    function clearBookingUrlEventIdKeepVariant() {
      var patch = { eventId: '' };
      if (state.lockedVariantId) patch.variantId = state.lockedVariantId;
      updateWizardBookingUrl(patch);
    }

    function syncBookingUrlForVenueStep(venue) {
      var token = venueUrlToken(venue);
      updateWizardBookingUrl({
        venue: token || '',
        eventId: '',
      });
    }

    function syncBookingUrlForDatetimeStep(slot) {
      var patch = { venue: resolveVenueHandleForUrl() || venueUrlToken(state.selectedVenue) || '' };
      if (slot) {
        var raw = slot._raw || {};
        patch.eventId = String(raw.id || raw.gid || slot.gid || '').trim();
      } else {
        patch.eventId = '';
      }
      if (state.lockedVariantId) patch.variantId = state.lockedVariantId;
      updateWizardBookingUrl(patch);
      updateProductVenueSeoCopy();
    }

    function syncBookingUrlVariantOnStep3(variantId) {
      if (state.branch !== 'variants') return;
      var id = vQtyKey(variantId);
      if (!id) return;
      state.lockedVariantId = id;
      state.focusedVariantId = id;
      updateWizardBookingUrl({
        variantId: id,
        venue: resolveVenueHandleForUrl() || venueUrlToken(state.selectedVenue) || '',
      });
    }

    function ensureLockedVariantFromUrlOrSlot() {
      if (state.lockedVariantId) return;
      var fromUrl = readInitialVariantIdFromUrl();
      if (fromUrl) {
        state.lockedVariantId = fromUrl;
        return;
      }
    }

    function findSlotByEventId(eventId) {
      var urlNum = extractNumericEventIdForUrl(eventId);
      if (!urlNum || !state.slotList.length) return null;
      for (var si = 0; si < state.slotList.length; si++) {
        var s = state.slotList[si];
        var raw = s._raw || {};
        var num = extractNumericEventIdForUrl(raw.id || raw.gid || s.gid || '');
        if (num && num === urlNum) return s;
      }
      return null;
    }

    function findVenueCardByUrlToken(token, opts) {
      opts = opts || {};
      if (!eventsRoot || !token) return null;
      var allowFallback = opts.allowFallback !== false;
      var stateCode = typeof getStateCodeFromUrl === 'function' ? getStateCodeFromUrl() : '';
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      var i;
      var card;
      if (stateCode && !/^\d+$/.test(String(token).trim())) {
        for (i = 0; i < cards.length; i++) {
          card = cards[i];
          if (
            card._wbVenue &&
            venueMatchesUrlToken(card._wbVenue, token, {
              stateCode: stateCode,
              requireState: true,
            })
          ) {
            return card;
          }
        }
        if (!allowFallback) return null;
      }
      for (i = 0; i < cards.length; i++) {
        card = cards[i];
        if (card._wbVenue && venueMatchesUrlToken(card._wbVenue, token)) return card;
      }
      return null;
    }

    function applySlotToVariantStep(slot) {
      if (!slot || !slotBookable(slot)) return false;
      state.selectedSlot = slot;
      state.selectedDate = slotDateKey(slot);
      if (state.selectedDate) {
        var dp = state.selectedDate.split('-').map(Number);
        if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
      }
      syncWorkshopSelection(slot);
      setBranch('variants');
      hydrateVariantsDatetimeControls();
      renderVariants();
      updateVariantStepUi();
      syncBookingUrlForDatetimeStep(slot);
      syncCapacityRing();
      syncSiblingWorkshopPromo();
      return true;
    }

    function findVenueCardByEventId(eventId) {
      var urlNum = extractNumericEventIdForUrl(eventId);
      if (!urlNum || !eventsRoot) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var ci = 0; ci < cards.length; ci++) {
        var card = cards[ci];
        var venue = card._wbVenue;
        if (!venue || !Array.isArray(venue.events)) continue;
        for (var ei = 0; ei < venue.events.length; ei++) {
          var ev = venue.events[ei];
          var num = extractNumericEventIdForUrl(
            String((ev && ev.id) || '') || String((ev && ev.event_metaobject_gid) || '')
          );
          if (num && num === urlNum) return card;
        }
      }
      return null;
    }

    function findVenueCardForDeepLink(eventId, venueToken) {
      var stateCode =
        typeof getStateCodeFromUrl === 'function' ? getStateCodeFromUrl() : '';
      var hasStateFilter = !!(stateCode && venueToken && !/^\d+$/.test(String(venueToken).trim()));

      if (venueToken) {
        /* With state: only strict card match here; venue-only fallback after catalog. */
        var byVenue = findVenueCardByUrlToken(venueToken, {
          allowFallback: !hasStateFilter,
        });
        if (byVenue) return byVenue;
      }
      if (eventId) {
        var byEvent = findVenueCardByEventId(eventId);
        if (byEvent) return byEvent;
        var row = findIndexRowByEventId(venueWorkshopIndexRows, eventId);
        if (row) {
          var ref = extractNumericVenueRefForUrl(row.venue_ref_id);
          if (ref) {
            var byRef = findVenueCardByUrlToken(ref);
            if (byRef) return byRef;
          }
          var handle = String(row.venue_handle || '').trim();
          if (handle) {
            var byHandle = findVenueCardByUrlToken(handle, {
              allowFallback: !hasStateFilter,
            });
            if (byHandle) return byHandle;
          }
        }
      }
      if (venueToken && venueWaitlistCatalog.length) {
        var catalogVenue = null;
        if (hasStateFilter) {
          catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken, {
            stateCode: stateCode,
            requireState: true,
          });
        }
        if (!catalogVenue) {
          catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken);
        }
        if (catalogVenue) {
          var catalogRef = extractNumericVenueRefForUrl(catalogVenue.venue_ref_id);
          if (catalogRef) {
            var byCatalogRef = findVenueCardByUrlToken(catalogRef);
            if (byCatalogRef) return byCatalogRef;
          }
        }
      }
      /* Last resort: venue-only card match when state was present but nothing matched. */
      if (hasStateFilter) {
        return findVenueCardByUrlToken(venueToken, { allowFallback: true });
      }
      return null;
    }

    function resolveDeepLinkEventId(eventId, venueToken) {
      eventId = String(eventId || '').trim();
      if (!eventId || !state.selectedVenue) return eventId;
      if (slotListContainsEventId(state.slotList, eventId)) return eventId;
      if (!venueToken) return eventId;
      var productHandle = data.productHandle || wizardRoot.getAttribute('data-product-handle');
      var corrected = resolveEventIdForProductAtVenue(
        productHandle,
        state.selectedVenue,
        state.selectedVenueCard,
        eventId,
        venueWorkshopIndexRows
      );
      return corrected || eventId;
    }

    function primeVenueLabelFromUrl() {
      if (state.venueDisplayLabel) return;
      var label = resolveVenueLabelFromDeepLink();
      if (label) state.venueDisplayLabel = label;
    }

    function tryApplyWizardUrlDeepLink() {
      if (wizardRoot.__wbwUrlDeepLinkComplete) return;
      if (wizardRoot.__wbwUserReachedDatetime) return;
      if (!eventsRoot) return;
      /* Typing / filtering venues must never auto-jump to Step 2. */
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) return;
      if (state.branch === 'datetime' || state.branch === 'variants') return;

      var venueToken = getVenueTokenFromUrl();
      var eventId = getEventIdFromUrl();
      var wbwStep = getWbwStepFromUrl();
      if (!venueToken && !eventId) return;

      primeVenueLabelFromUrl();

      var venueCard = findVenueCardForDeepLink(eventId, venueToken);
      if (!venueCard) {
        if (state.venueDisplayLabel && state.branch !== 'venue') updateProductVenueSeoCopy();
        return;
      }

      if (eventId && venueCardIsWaitlistOnly(venueCard) && !urlHasWizardDeepLink()) return;

      selectVenueCard(venueCard, { updatePageCopy: true, skipAnalytics: true });
      if (state.flow === 'waitlist') {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        setBranch('venue');
        return;
      }
      var advanceToBooking = !!(
        venueToken ||
        eventId ||
        wbwStep === 'datetime' ||
        wbwStep === 'variants'
      );
      if (!advanceToBooking) return;
      /* One-shot: mark before async so list re-renders cannot re-enter. */
      wizardRoot.__wbwUrlDeepLinkComplete = true;
      wizardRoot.__wbwDeepLinking = true;
      var startStep = isStoreVenue(state.selectedVenue) ? startDatetimeStep : startPopupBookingStep;
      startStep()
        .then(function () {
        if (!eventId) {
          if (state.branch === 'datetime' || state.branch === 'variants') {
            updateProductVenueSeoCopy();
          }
          return;
        }

        var resolvedEventId = resolveDeepLinkEventId(eventId, venueToken);
        var slot = findSlotByEventId(resolvedEventId);
        if (!slot || !slotVisible(slot)) return;

        if (resolvedEventId !== eventId) {
          syncBookingUrlForDatetimeStep(slot);
        }

        if (state.branch === 'waitlist') {
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
        }

        var variantId = readInitialVariantIdFromUrl();
        var wantVariants = !!(variantId || wbwStep === 'variants');
        if (wantVariants && slotBookable(slot)) {
          applySlotToVariantStep(slot);
          if (!isStoreVenue(state.selectedVenue)) {
            refreshPopupDatetimeControls({
              preferredDate: slotDateKey(slot),
              preferredGid: slot.gid,
              apply: false,
            });
            syncPopupDatetimePanel();
          }
          state.lockedVariantId = variantId;
          previewWizardVariant(variantId);
          var qKey = vQtyKey(variantId);
          if (!state.variantQty[qKey]) state.variantQty[qKey] = 1;
          refreshVariantRowUI(qKey);
          updateVariantStepUi();
          updateProductVenueSeoCopy();
          return;
        }

        if (!isStoreVenue(state.selectedVenue)) {
          state.selectedDate = slotDateKey(slot);
          state.selectedSlot = slot;
          refreshPopupDatetimeControls({
            preferredDate: state.selectedDate,
            preferredGid: slot.gid,
            apply: true,
          });
          ensureLockedVariantFromUrlOrSlot();
          window.__WB_LOCK_VARIANT_URL__ = true;
          syncWorkshopSelection(slot);
          syncBookingUrlForDatetimeStep(slot);
          renderVariants();
          updateVariantStepUi();
          updateProductVenueSeoCopy();
          return;
        }

        applySlotToDatetimeStep(slot);
        updateProductVenueSeoCopy();
      })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          try {
            console.warn('[wbw] deep-link step start failed', err);
          } catch (_) {}
          try {
            document.documentElement.removeAttribute('data-wbw-deeplink');
          } catch (_) {}
          setBranch('venue');
        })
        .then(function () {
          wizardRoot.__wbwDeepLinking = false;
        });
    }

    function stepEl(name) {
      return wizardRoot.querySelector('[data-wbw-step="' + name + '"]');
    }

    function updateProgressLabels() {
      var popupBooking =
        state.flow === 'booking' && state.selectedVenue && !isStoreVenue(state.selectedVenue);
      var total = popupBooking ? 2 : 3;
      var labels = popupBooking
        ? { venue: 1, waitlist: 1, datetime: 2, variants: 2 }
        : { venue: 1, waitlist: 1, datetime: 2, variants: 3 };
      wizardRoot.setAttribute('data-wbw-step-n', String(labels[state.branch] || 1));
      wizardRoot.setAttribute('data-wbw-step-total', String(total));
      wizardRoot.querySelectorAll('[data-wbw-progress]').forEach(function (p) {
        var step = state.branch;
        var n = labels[step] || 1;
        p.textContent = 'Step ' + n + ' of ' + total;
        p.setAttribute('data-wbw-step-n', String(n));
        p.setAttribute('data-wbw-step-total', String(total));
      });
      var venueFoot = stepEl('venue');
      if (venueFoot) {
        var solo = venueFoot.querySelector('[data-wbw-progress]');
        if (solo) {
          solo.textContent = 'Step 1 of ' + total;
          solo.setAttribute('data-wbw-step-n', '1');
          solo.setAttribute('data-wbw-step-total', String(total));
        }
      }
    }

    function syncVenueKindAttr() {
      var kind = 'store';
      if (state.selectedVenue) {
        kind = isStoreVenue(state.selectedVenue) ? 'store' : 'popup';
      }
      wizardRoot.setAttribute('data-wbw-venue-kind', kind);
      return kind;
    }

    function wbwAnalytics() {
      return global.WorkshopBookingWizardAnalytics || null;
    }

    function wbwTrack(eventName, extra) {
      var api = wbwAnalytics();
      if (!api || typeof api.track !== 'function') return;
      api.track(eventName, state, wizardRoot, data, extra || {});
    }

    function setBranch(branch, opts) {
      opts = opts || {};
      if (branch !== 'datetime') closeCalTimeDd();
      state.branch = branch;
      wizardRoot.setAttribute('data-wbw-branch', branch);
      var skipStepTrack = opts.track === false || !!wizardRoot.__wbwDeepLinking;
      if (!skipStepTrack) {
        var apiStep = wbwAnalytics();
        if (apiStep && typeof apiStep.trackStepView === 'function') {
          apiStep.trackStepView(state, wizardRoot, data, branch);
        } else {
          wbwTrack('wbw_step_view', { wbw_step: branch });
        }
      }
      syncVenueKindAttr();
      if (branch === 'datetime') {
        window.__WB_LOCK_VARIANT_URL__ = true;
      } else if (branch !== 'variants') {
        window.__WB_LOCK_VARIANT_URL__ = false;
      }
      ALL_STEPS.forEach(function (s) {
        var el = stepEl(s);
        if (!el) return;
        var on = s === branch;
        el.hidden = !on;
        el.classList.toggle('wcf-step--on', on);
      });
      updateProgressLabels();
      syncPopupDatetimePanel();
      if (branch === 'datetime') {
        syncCapacityRing();
        if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
        else if (state.selectedVenue) syncBookingUrlForVenueStep(state.selectedVenue);
        updateWizardBookingUrl({ step: 'datetime' });
      } else if (branch === 'variants') {
        if (typeof S.wbwSyncVenueMapSelection === 'function') S.wbwSyncVenueMapSelection();
        if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
        updateWizardBookingUrl({ step: 'variants' });
      } else {
        updateWizardBookingUrl({ step: '' });
      }
      try {
        document.documentElement.removeAttribute('data-wbw-deeplink');
      } catch (_) {}
      /* Step 1: never write ?venue= here (select / Back clear URL explicitly). */
      syncSiblingWorkshopPromo();
      updateProductVenueSeoCopy();
      if (typeof window.wbSyncBelowWaitlistPanel === 'function') {
        window.wbSyncBelowWaitlistPanel({
          wizard: wizardRoot,
          venue: state.selectedVenue,
          bookingRoot: bookingRoot,
        });
      }
    }

    function venueProductHandles(venue) {
      var out = Object.create(null);
      if (!venue) return out;
      venueRefAliasKeys(venue.venue_ref_id).forEach(function (ref) {
        if (ref && venueWorkshopMap[ref]) {
          Object.keys(venueWorkshopMap[ref]).forEach(function (h) {
            out[h] = true;
          });
        }
      });
      var nameKey = venueNameLookupKey(venue.venue_name || venue.name || venue.city_name);
      if (nameKey && venueWorkshopMapByName[nameKey]) {
        Object.keys(venueWorkshopMapByName[nameKey]).forEach(function (h) {
          out[h] = true;
        });
      }
      if (nameKey && nameKey.length >= 4) {
        Object.keys(venueWorkshopMapByName).forEach(function (idxKey) {
          if (idxKey === nameKey) return;
          if (idxKey.indexOf(nameKey) >= 0 || nameKey.indexOf(idxKey) >= 0) {
            Object.keys(venueWorkshopMapByName[idxKey]).forEach(function (h) {
              out[h] = true;
            });
          }
        });
      }
      var cityKey = venueNameLookupKey(venue.city || venue.city_name || '');
      if (cityKey && cityKey.length >= 4 && cityKey !== nameKey) {
        Object.keys(venueWorkshopMapByName).forEach(function (idxKey) {
          if (idxKey.indexOf(cityKey) >= 0) {
            Object.keys(venueWorkshopMapByName[idxKey]).forEach(function (h) {
              out[h] = true;
            });
          }
        });
      }
      var evs = Array.isArray(venue.events) ? venue.events : [];
      evs.forEach(function (ev) {
        if (!ev) return;
        var ph = String(ev.product_handle || ev.productHandle || '')
          .trim()
          .toLowerCase();
        if (ph) out[ph] = true;
        collectAlsoAvailableHandles(ev, out);
        var av = ev.available_variants;
        if (Array.isArray(av)) {
          av.forEach(function (it) {
            var h3 = String((it && (it.product_handle || it.productHandle)) || '')
              .trim()
              .toLowerCase();
            if (h3) out[h3] = true;
          });
        }
      });
      if (state.selectedSlot && state.selectedSlot._raw) {
        collectAlsoAvailableHandles(state.selectedSlot._raw, out);
        var slotAv = state.selectedSlot._raw.available_variants;
        if (Array.isArray(slotAv)) {
          slotAv.forEach(function (it) {
            var h4 = String((it && (it.product_handle || it.productHandle)) || '')
              .trim()
              .toLowerCase();
            if (h4) out[h4] = true;
          });
        }
      }
      return out;
    }

    function venueDisplayName(venue) {
      if (!venue) return '';
      var fromVenue = String(venue.venue_name || venue.name || venue.city_name || '').trim();
      if (fromVenue) return fromVenue;
      if (state.selectedVenueCard) {
        return String(state.selectedVenueCard.getAttribute('data-wbw-city-label') || '').trim();
      }
      return '';
    }

    function promoImageForHandle(handle) {
      var h = String(handle || '')
        .trim()
        .toLowerCase();
      var entry = promoCatalogByHandle.get(h);
      return entry && entry.image ? entry.image : '';
    }

    function promoMetaForHandle(handle) {
      var h = String(handle || '')
        .trim()
        .toLowerCase();
      return promoCatalogByHandle.get(h) || null;
    }

    function findPromoEventIdFromIndex(targetHandle) {
      return resolvePromoDeepLinkFromIndex(
        targetHandle,
        data.productHandle || wizardRoot.getAttribute('data-product-handle'),
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows
      ).eventId;
    }

    function absorbAlsoAvailableEventId(targetHandle) {
      targetHandle = String(targetHandle || '')
        .trim()
        .toLowerCase();
      if (!targetHandle) return '';

      function scanSource(source) {
        if (!source) return '';
        if (Array.isArray(source.also_available_products)) {
          for (var ai = 0; ai < source.also_available_products.length; ai++) {
            var p = source.also_available_products[ai];
            if (!handlesMatchForPromo(p && p.handle, targetHandle)) continue;
            var fromAa = extractPromoEventIdFromProduct(p);
            if (fromAa) return fromAa;
          }
        }
        if (Array.isArray(source.available_variants)) {
          for (var vi = 0; vi < source.available_variants.length; vi++) {
            var it = source.available_variants[vi];
            if (!handlesMatchForPromo(it && (it.product_handle || it.productHandle), targetHandle)) {
              continue;
            }
            var fromAv = extractPromoEventIdFromProduct(it);
            if (fromAv) return fromAv;
          }
        }
        return '';
      }

      var fromSlot = scanSource(state.selectedSlot && state.selectedSlot._raw);
      if (fromSlot) return fromSlot;
      if (state.selectedVenue && Array.isArray(state.selectedVenue.events)) {
        for (var ei = 0; ei < state.selectedVenue.events.length; ei++) {
          var fromEv = scanSource(state.selectedVenue.events[ei]);
          if (fromEv) return fromEv;
        }
      }
      return '';
    }

    function resolvePromoDeepLink(targetHandle) {
      targetHandle = String(targetHandle || '')
        .trim()
        .toLowerCase();
      if (!targetHandle) return { eventId: '', venueHandle: '' };

      var venueToken = venueUrlToken(state.selectedVenue) || '';

      if (state.selectedSlot) {
        var fromSessionAnchor = resolveSiblingEventIdFromSessionAnchor(
          targetHandle,
          state.selectedSlot,
          state.selectedVenue,
          state.selectedVenueCard,
          venueWorkshopIndexRows
        );
        if (fromSessionAnchor) {
          return { eventId: fromSessionAnchor, venueHandle: venueToken };
        }
      }

      var fromIndex = resolvePromoDeepLinkFromIndex(
        targetHandle,
        data.productHandle || wizardRoot.getAttribute('data-product-handle'),
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows
      );
      if (fromIndex.eventId) return fromIndex;

      var fromAa = absorbAlsoAvailableEventId(targetHandle);
      if (
        fromAa &&
        promoEventIdMatchesVenueContext(
          fromAa,
          state.selectedVenue,
          state.selectedVenueCard,
          state.selectedSlot,
          venueWorkshopIndexRows
        )
      ) {
        return { eventId: fromAa, venueHandle: venueToken };
      }

      if (!state.selectedVenue || !state.selectedSlot) return { eventId: '', venueHandle: '' };
      var curDate = slotDateKey(state.selectedSlot);
      var curTime = normalizeTimeLabel(state.selectedSlot.time_label);
      var evs = Array.isArray(state.selectedVenue.events) ? state.selectedVenue.events : [];

      for (var ei = 0; ei < evs.length; ei++) {
        var ev = evs[ei];
        if (!ev) continue;
        if (!handlesMatchForPromo(ev.product_handle || ev.productHandle, targetHandle)) continue;
        var slot = normalizeEventToSlot(ev);
        if (!slot) continue;
        if (curDate && slotDateKey(slot) !== curDate) continue;
        if (curTime && normalizeTimeLabel(slot.time_label) !== curTime) continue;
        var num = extractNumericEventIdForUrl(
          ev.id || ev.gid || ev.event_metaobject_gid || slot.gid || ''
        );
        if (num) {
          return {
            eventId: num,
            venueHandle: String(ev.venue_handle || '').trim(),
          };
        }
      }

      for (var ej = 0; ej < evs.length; ej++) {
        var ev2 = evs[ej];
        if (!ev2) continue;
        if (!handlesMatchForPromo(ev2.product_handle || ev2.productHandle, targetHandle)) continue;
        var slot2 = normalizeEventToSlot(ev2);
        if (!slot2) continue;
        if (curDate && slotDateKey(slot2) !== curDate) continue;
        var num2 = extractNumericEventIdForUrl(
          ev2.id || ev2.gid || ev2.event_metaobject_gid || slot2.gid || ''
        );
        if (num2) {
          return {
            eventId: num2,
            venueHandle: String(ev2.venue_handle || '').trim(),
          };
        }
      }

      return { eventId: '', venueHandle: '' };
    }

    function findPromoEventIdForHandle(targetHandle) {
      return resolvePromoDeepLink(targetHandle).eventId;
    }

    function buildPromoProductUrl(prod) {
      var base = String((prod && prod.url) || '').trim();
      if (!base && prod && prod.handle) base = '/products/' + encodeURIComponent(prod.handle);
      if (!base) return '#';
      var targetHandle = prod && prod.handle;
      var currentHandle = data.productHandle || wizardRoot.getAttribute('data-product-handle');
      var eventId = resolveVenueAnchoredPromoEventId(
        targetHandle,
        currentHandle,
        state.selectedVenue,
        state.selectedVenueCard,
        state.selectedSlot,
        venueWorkshopIndexRows,
        (prod && prod.promoEventId) || ''
      );
      if (!eventId && prod && prod.url) eventId = extractEventIdFromUrl(prod.url);
      var venueToken =
        venueUrlToken(state.selectedVenue) ||
        venueHandleFromSlotRaw(state.selectedSlot && state.selectedSlot._raw) ||
        '';
      try {
        var u = new URL(base, window.location.origin);
        var eid = eventId ? extractNumericEventIdForUrl(eventId) : '';
        if (venueToken) u.searchParams.set('venue', venueToken);
        if (eid) u.searchParams.set('event_id', eid);
        return u.pathname + u.search;
      } catch (_) {
        var qs = [];
        var eid2 = eventId ? extractNumericEventIdForUrl(eventId) : '';
        if (venueToken) qs.push('venue=' + encodeURIComponent(venueToken));
        if (eid2) qs.push('event_id=' + encodeURIComponent(eid2));
        return base + (base.indexOf('?') > -1 ? '&' : '?') + qs.join('&');
      }
    }

    function collectPromoWorkshops() {
      var current = String(data.productHandle || wizardRoot.getAttribute('data-product-handle') || '')
        .trim()
        .toLowerCase();
      var map = new Map();

      function putPromo(h, opts) {
        opts = opts || {};
        h = String(h || '')
          .trim()
          .toLowerCase();
        if (!h) return;
        var key = canonicalPromoHandle(h);
        if (!key || handlesMatchForPromo(key, current) || map.has(key)) return;
        var fromAlsoAvailable = !!opts.fromAlsoAvailable;
        var fromSessionIndex = !!opts.fromSessionIndex;
        var promoEventId = extractNumericEventIdForUrl(opts.promoEventId || '');
        if (state.selectedSlot && (fromAlsoAvailable || fromSessionIndex || !promoEventId)) {
          promoEventId =
            resolveVenueAnchoredPromoEventId(
              key,
              current,
              state.selectedVenue,
              state.selectedVenueCard,
              state.selectedSlot,
              venueWorkshopIndexRows,
              opts.promoEventId || ''
            ) || promoEventId;
        }
        if (!promoEventId && !fromAlsoAvailable && !fromSessionIndex) return;
        var meta = promoMetaForHandle(key) || promoMetaForHandle(h);
        map.set(key, {
          handle: key,
          title: String(
            opts.title || (meta && meta.title) || WB_SIBLING_LABELS[key] || WB_SIBLING_LABELS[h] || key
          ).trim(),
          url: String(
            opts.url || (meta && meta.url) || '/products/' + encodeURIComponent(key)
          ).trim(),
          image: String(opts.image || (meta && meta.image) || promoImageForHandle(key) || '').trim(),
          promoEventId: promoEventId || '',
          fromAlsoAvailable: fromAlsoAvailable,
        });
      }

      function absorbAlsoAvailable(source) {
        if (!source) return;
        var arr = source.also_available_products;
        if (Array.isArray(arr)) {
          arr.forEach(function (p) {
            if (!p) return;
            var h = String(p.handle || p.product_handle || p.productHandle || '')
              .trim()
              .toLowerCase();
            if (!h) return;
            putPromo(h, {
              title: p.title || p.product_title || p.productTitle,
              url: p.url || p.product_url || p.productUrl,
              image: p.image || p.featured_image || p.product_image || p.productImage,
              promoEventId: extractPromoEventIdFromProduct(p),
              fromAlsoAvailable: true,
            });
          });
        }
        if (Array.isArray(source.available_variants)) {
          source.available_variants.forEach(function (it) {
            if (!it) return;
            var h = String(it.product_handle || it.productHandle || '')
              .trim()
              .toLowerCase();
            if (!h) return;
            putPromo(h, {
              title: it.product_title || it.productTitle || it.title,
              url: it.product_url || it.productUrl,
              image: it.product_image || it.productImage || it.image,
              promoEventId: extractPromoEventIdFromProduct(it),
              fromAlsoAvailable: true,
            });
          });
        }
      }

      function promoAlsoAvailableSources() {
        var out = [];
        if (!state.selectedSlot) return out;
        var seen = Object.create(null);
        function add(src) {
          if (!src || typeof src !== 'object') return;
          var id = extractNumericEventIdForUrl(
            src.id || src.gid || src.event_metaobject_gid || src.event_id || ''
          );
          var dk = String(src.date_key || '').trim();
          var tl = normalizeTimeLabel(src.time_label || '');
          var key = (id || 'x') + '|' + dk + '|' + tl;
          if (seen[key]) return;
          seen[key] = true;
          out.push(src);
        }

        var curKey = slotMatchKey(state.selectedSlot);
        var curDate = slotDateKey(state.selectedSlot);
        var curTime = normalizeTimeLabel(state.selectedSlot.time_label);
        if (!curDate || !curTime) return out;

        if (state.selectedSlot._raw) add(state.selectedSlot._raw);

        var evs =
          state.selectedVenue && Array.isArray(state.selectedVenue.events)
            ? state.selectedVenue.events
            : [];
        evs.forEach(function (ev) {
          var slot = normalizeEventToSlot(ev);
          if (!slot) return;
          if (curKey && slotMatchKey(slot) === curKey) {
            add(ev);
            return;
          }
          if (slotDateKey(slot) === curDate && normalizeTimeLabel(slot.time_label) === curTime) {
            add(ev);
          }
        });

        return out;
      }

      promoAlsoAvailableSources().forEach(absorbAlsoAvailable);

      if (state.selectedVenue && state.selectedSlot && venueWorkshopIndexRows.length) {
        WB_HANDLE_ALIAS_GROUPS.forEach(function (group) {
          if (group.some(function (gh) { return handlesMatchForPromo(gh, current); })) return;
          var targetHandle = group[0];
          var eventId = resolveSiblingEventIdFromSessionAnchor(
            targetHandle,
            state.selectedSlot,
            state.selectedVenue,
            state.selectedVenueCard,
            venueWorkshopIndexRows
          );
          if (!eventId) return;
          putPromo(targetHandle, { fromSessionIndex: true, promoEventId: eventId });
        });
      }

      return Array.from(map.values());
    }

    function buildPromoCardHtml(prod, subtitle) {
      var label = prod.title || prod.handle || 'Workshop';
      var href = buildPromoProductUrl(prod);
      var imgHtml = prod.image
        ? '<span class="wbw-sibling-promo-card__media"><img class="wbw-sibling-promo-card__img" src="' +
          escapeHtml(prod.image) +
          '" alt="' +
          escapeHtml(label) +
          '" width="200" height="150" loading="lazy" decoding="async"></span>'
        : '<span class="wbw-sibling-promo-card__media wbw-sibling-promo-card__media--placeholder" aria-hidden="true"><span class="wbw-sibling-promo-card__placeholder-mark">✦</span></span>';
      var subtitleHtml = subtitle
        ? '<span class="wbw-sibling-promo-card__subtitle">' + escapeHtml(subtitle) + '</span>'
        : '';
      return (
        '<a class="wbw-sibling-promo-card" href="' +
        escapeHtml(href) +
        '">' +
        imgHtml +
        '<span class="wbw-sibling-promo-card__body">' +
        '<span class="wbw-sibling-promo-card__title">' +
        escapeHtml(label) +
        '</span>' +
        subtitleHtml +
        '<span class="wbw-sibling-promo-card__cta">Explore <span aria-hidden="true">→</span></span>' +
        '</span></a>'
      );
    }

    function buildPromoListHtml(items) {
      var eyebrow = escapeHtml(siblingPromoEyebrow || 'Also available as');
      var venueName = items.length === 1 ? venueDisplayName(state.selectedVenue) : '';
      var cardsHtml = items
        .map(function (p) {
          var subtitle = venueName ? 'Available in ' + venueName : '';
          return buildPromoCardHtml(p, subtitle);
        })
        .join('');
      return (
        '<div class="wbw-sibling-promo-panel">' +
        '<p class="wbw-sibling-promo-panel__eyebrow">' +
        eyebrow +
        '</p>' +
        '<div class="wbw-sibling-promo-grid' +
        (items.length === 1 ? ' wbw-sibling-promo-grid--single' : '') +
        '">' +
        cardsHtml +
        '</div></div>'
      );
    }

    function getPromoNodes() {
      ensureSiblingPromoDom(wizardRoot, sectionId);
      var hosts = siblingPromoHosts(wizardRoot, sectionId);
      var host = null;
      var slot = wizardRoot.querySelector('[data-wbw-promo-slot]');
      if (slot) {
        host = slot.querySelector('[data-workshop-sibling-promo]');
      }
      if (!host && hosts.length) host = hosts[0];
      return {
        hosts: hosts,
        host: host,
        wrap: host && host.querySelector('[data-wbw-sibling-promo-wrap]'),
        list: host && host.querySelector('[data-wbw-sibling-promo-list]'),
      };
    }

    function applyPromoPanelState(hosts, show, listHtml) {
      (hosts || []).forEach(function (host) {
        if (!host) return;
        var wrap = host.querySelector('[data-wbw-sibling-promo-wrap]');
        var list = host.querySelector('[data-wbw-sibling-promo-list]');
        if (!wrap || !list) return;
        if (!show) {
          wrap.hidden = true;
          wrap.setAttribute('aria-hidden', 'true');
          list.innerHTML = '';
          return;
        }
        list.innerHTML = listHtml;
        wrap.hidden = false;
        wrap.setAttribute('aria-hidden', 'false');
      });
    }

    function syncSiblingWorkshopPromo() {
      var promoNodes = getPromoNodes();
      var hosts = promoNodes.hosts || [];
      var wrap = promoNodes.wrap;
      var list = promoNodes.list;
      var show =
        state.branch === 'variants' &&
        state.selectedVenue &&
        state.flow === 'booking' &&
        state.selectedSlot;
      var diagBase = {
        show: show,
        branch: state.branch,
        flow: state.flow,
        hasVenue: !!state.selectedVenue,
        hasSlot: !!state.selectedSlot,
        hostCount: hosts.length,
        hasWrap: !!wrap,
        hasList: !!list,
        slotAaLen:
          state.selectedSlot &&
          state.selectedSlot._raw &&
          Array.isArray(state.selectedSlot._raw.also_available_products)
            ? state.selectedSlot._raw.also_available_products.length
            : 0,
        venueEvents: state.selectedVenue && state.selectedVenue.events ? state.selectedVenue.events.length : 0,
        itemCount: 0,
      };
      if (!hosts.length || !wrap || !list) {
        diagBase.phase = 'no-promo-nodes';
        try {
          window.__wbwPromoDiag = diagBase;
        } catch (_diagErr0) {}
        return;
      }
      var step = stepEl('variants');
      if (step) {
        step.querySelectorAll('[data-wbw-also-available]').forEach(function (node) {
          node.remove();
        });
      }
      if (!show) {
        diagBase.phase = 'hidden';
        try {
          window.__wbwPromoDiag = diagBase;
        } catch (_diagErr1) {}
        applyPromoPanelState(hosts, false, '');
        return;
      }
      var items = collectPromoWorkshops();
      diagBase.itemCount = items.length;
      diagBase.phase = 'sync';
      try {
        window.__wbwPromoDiag = diagBase;
      } catch (_diagErr2) {}
      if (!items.length) {
        applyPromoPanelState(hosts, false, '');
        return;
      }
      applyPromoPanelState(hosts, true, buildPromoListHtml(items));
    }

    function getPriceContext(slot) {
      var raw = (slot && slot._raw) || {};
      var venue = state.selectedVenue || {};
      return {
        eventId: String(raw.id || raw.gid || (slot && slot.gid) || '').trim(),
        state: String(raw.state || venue.state || '').trim(),
        city: String(raw.city || venue.city || venue.city_name || '').trim(),
        cityKey: '',
        venueName: String(raw.venue_name || raw.venue || venue.venue_name || venue.name || '').trim(),
        venueHandle: String(raw.venue_handle || venue.venue_handle || '').trim(),
      };
    }

    function resolveVariantPriceCents(variant, slot) {
      if (variant && variant._isAddon) return Number(variant.price) || 0;
      var base = Number(variant && variant.price) || 0;
      if (!slot || typeof window.resolveWorkshopPrice !== 'function') return base;
      var ctx = getPriceContext(slot);
      try {
        return window.resolveWorkshopPrice({
          basePriceCents: base,
          eventId: ctx.eventId,
          state: ctx.state,
          city: ctx.city,
          cityKey: ctx.cityKey,
          venueName: ctx.venueName,
          venueHandle: ctx.venueHandle,
          variantId: String(variant.id),
          workshopId: productId,
        });
      } catch (_) {
        return base;
      }
    }

    function resolveVenueDisplayLabel(venue, card) {
      if (card) {
        var fromCard = String(card.getAttribute('data-wbw-city-label') || '').trim();
        if (fromCard) return fromCard;
      }
      if (!venue) return '';
      return String(venue.city_name || venue.city || venue.venue_name || venue.name || '').trim();
    }

    function resolveVenueLabelFromDeepLink() {
      if (state.venueDisplayLabel) return state.venueDisplayLabel;
      if (state.selectedVenueCard || state.selectedVenue) {
        var live = resolveVenueDisplayLabel(state.selectedVenue, state.selectedVenueCard);
        if (live) return live;
      }

      var venueToken = getVenueTokenFromUrl();
      var eventId = getEventIdFromUrl();
      if (!venueToken && !eventId) return '';

      var row = eventId ? findIndexRowByEventId(venueWorkshopIndexRows, eventId) : null;
      if (!row && venueToken) {
        var tokenNum = extractNumericVenueRefForUrl(venueToken);
        if (tokenNum) {
          for (var ri = 0; ri < venueWorkshopIndexRows.length; ri++) {
            var indexRow = venueWorkshopIndexRows[ri];
            if (!indexRow) continue;
            if (extractNumericVenueRefForUrl(indexRow.venue_ref_id) === tokenNum) {
              row = indexRow;
              break;
            }
          }
        }
      }
      if (row) return String(row.city || row.venue_name || '').trim();

      var labelState =
        typeof getStateCodeFromUrl === 'function' ? getStateCodeFromUrl() : '';
      var catalogVenue = null;
      if (venueToken && labelState && !/^\d+$/.test(String(venueToken).trim())) {
        catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken, {
          stateCode: labelState,
          requireState: true,
        });
      }
      if (!catalogVenue && venueToken) {
        catalogVenue = findCatalogVenueByToken(venueWaitlistCatalog, venueToken);
      }
      if (catalogVenue) return String(catalogVenue.venue_name || '').trim();
      return '';
    }

    function venueLabelForWizard() {
      if (state.venueDisplayLabel) return state.venueDisplayLabel;
      var card = state.selectedVenueCard;
      if (card) {
        var fromCard = String(card.getAttribute('data-wbw-city-label') || '').trim();
        if (fromCard) return fromCard;
      }
      var v = state.selectedVenue;
      if (!v) return resolveVenueLabelFromDeepLink();
      return String(v.city_name || v.city || v.venue_name || v.name || '').trim();
    }

    var Seo = window.WorkshopBookingWizardSeo || {};
    var wbwCityDescLeadClass = Seo.CITY_DESC_LEAD_CLASS || 'wbw-city-desc-lead';
    var normalizeWorkshopLabel = Seo.normalizeWorkshopLabel;
    var isNodeAfter = Seo.isNodeAfter;
    var findWorkshopEyebrow = Seo.findWorkshopEyebrow;
    var syncWorkshopEyebrow = Seo.syncWorkshopEyebrow;
    var findCityDescAnchor = Seo.findCityDescAnchor;
    var placeCityDescLead = Seo.placeCityDescLead;
    var buildVenueSeoTitle = Seo.buildVenueSeoTitle;
    var fitProductSeoH1 = Seo.fitProductSeoH1;

    function updateProductVenueSeoCopy() {
      var baseTitle = String(wizardRoot.getAttribute('data-wbw-product-title') || '').trim();
      var sectionId = String(wizardRoot.getAttribute('data-section-id') || '').trim();
      var city = '';
      if (state.branch !== 'venue') {
        city = venueLabelForWizard() || resolveVenueLabelFromDeepLink();
      }
      var dateKey = state.selectedDate || (state.selectedSlot ? slotDateKey(state.selectedSlot) : '');
      var dateLabel =
        dateKey && typeof formatPopupDateLabel === 'function' ? formatPopupDateLabel(dateKey) : dateKey;
      var seoTitle = buildVenueSeoTitle(baseTitle, city);
      var leadText =
        typeof Seo.buildVenueSeoDescription === 'function'
          ? Seo.buildVenueSeoDescription(city, dateLabel)
          : city
            ? 'Join us in ' + city + ' for this hands-on workshop experience.'
            : '';
      var productRoot = sectionId ? document.querySelector('.main-product-' + sectionId) : null;

      if (baseTitle && productRoot) {
        productRoot.querySelectorAll('.product-title').forEach(function (titleEl) {
          titleEl.textContent = seoTitle;
          fitProductSeoH1(titleEl, !!city);
        });
      }

      if (typeof Seo.syncBookingSeoHead === 'function') {
        Seo.syncBookingSeoHead({
          title: seoTitle || baseTitle,
          description: leadText,
          city: city,
        });
      }
      if (typeof Seo.syncBookingEventJsonLd === 'function') {
        var slot = state.selectedSlot;
        Seo.syncBookingEventJsonLd({
          name: seoTitle || baseTitle,
          city: city,
          venueName: city,
          description: leadText,
          startDate: slot && (slot.schema_start || slot.starts_at || ''),
          endDate: slot && (slot.schema_end || slot.ends_at || ''),
        });
      }

      if (!sectionId) return;

      var rte = document.querySelector('#product-description-block-' + sectionId + ' .rte');
      if (!rte) return;

      var lead = rte.querySelector('.' + wbwCityDescLeadClass);
      if (!city) {
        if (lead) lead.remove();
        syncWorkshopEyebrow(rte, baseTitle, '');
        return;
      }

      syncWorkshopEyebrow(rte, baseTitle, city);

      var eyebrow = findWorkshopEyebrow(rte, baseTitle);
      var anchor = findCityDescAnchor(rte, eyebrow);

      if (!lead) {
        lead = document.createElement('p');
        lead.className = wbwCityDescLeadClass;
        lead.textContent = leadText;
        placeCityDescLead(rte, lead, anchor);
        return;
      }

      lead.textContent = leadText;
      placeCityDescLead(rte, lead, anchor);
    }

    function updateBranchTitles() {
      var vn = venueLabelForWizard() || resolveVenueLabelFromDeepLink();
      var dt = stepEl('datetime');
      if (dt) {
        var calTitle = dt.querySelector('[data-wbw-cal-title]');
        if (calTitle) calTitle.textContent = 'Select a date';
      }
      var wl = stepEl('waitlist');
      if (wl) {
        var wlTitle = wl.querySelector('[data-wbw-wl-title]');
        if (wlTitle) {
          wlTitle.textContent = vn
            ? 'No workshops scheduled for ' + vn + ' yet'
            : 'No workshops scheduled yet';
        }
      }
    }

    /** Keep selection after venue list re-render (geo / refetch wipes DOM nodes). */

    /* live: workshop-booking-wizard-flow-live.js */
    var slotMatchKey = function () {};
    var syncSelectedVenueEventsFromSlots = function () {};
    var ensureLivePoll = function () {};
    var sweepViewMonthLive = function () {};
    var refreshLiveNow = function () {};
    var quietEnrichCurrentSlots = function () {};
    var resetLiveCursors = function () {};
    if (!global.WorkshopBookingWizardFlowLive || typeof global.WorkshopBookingWizardFlowLive.attach !== 'function') {
      console.error('[WBW] workshop-booking-wizard-flow-live.js missing');
    } else {
      S.bookingRoot = bookingRoot;
      S.eventsRoot = eventsRoot;
      S.liveController = liveController;
      S.liveFlags = liveFlags;
      S.liveRuntime = liveRuntime;
      S.state = state;
      S.stepEl = stepEl;
      S.wizardRoot = wizardRoot;
      global.WorkshopBookingWizardFlowLive.attach(S);
      slotMatchKey = S.slotMatchKey;
      syncSelectedVenueEventsFromSlots = S.syncSelectedVenueEventsFromSlots;
      ensureLivePoll = S.ensureLivePoll;
      sweepViewMonthLive = S.sweepViewMonthLive;
      refreshLiveNow = S.refreshLiveNow;
      quietEnrichCurrentSlots = S.quietEnrichCurrentSlots;
      resetLiveCursors = S.resetLiveCursors;
    }

    /* venue: workshop-booking-wizard-flow-venue.js */
    var rebindSelectedVenueCard = function () {};
    var updateVenueContinue = function () {};
    var closeWizardWaitlistModal = function () {};
    var clonePlainMap = function () {};
    var peekVenueSession = function () {};
    var stashVenueSession = function () {};
    var applySavedVenueSession = function () {};
    var clearVenueSelection = function () {};
    var onVenueResetEvent = function () {};
    var selectVenueCard = function () {};
    var bindVenueSelection = function () {};
    var goToNextFromVenue = function () {};
    if (!global.WorkshopBookingWizardFlowVenue || typeof global.WorkshopBookingWizardFlowVenue.attach !== 'function') {
      console.error('[WBW] workshop-booking-wizard-flow-venue.js missing');
    } else {
      S.bookingRoot = bookingRoot;
      S.eventsRoot = eventsRoot;
      S.resetLiveCursors = resetLiveCursors;
      S.resolveVenueDisplayLabel = resolveVenueDisplayLabel;
      S.setBranch = setBranch;
      S.state = state;
      S.stepEl = stepEl;
      S.syncVenueKindAttr = syncVenueKindAttr;
      S.updateBranchTitles = updateBranchTitles;
      S.updateProductVenueSeoCopy = updateProductVenueSeoCopy;
      S.updateProgressLabels = updateProgressLabels;
      S.venueLabelForWizard = venueLabelForWizard;
      S.wizardRoot = wizardRoot;
      S.data = data;
      global.WorkshopBookingWizardFlowVenue.attach(S);
      rebindSelectedVenueCard = S.rebindSelectedVenueCard;
      updateVenueContinue = S.updateVenueContinue;
      closeWizardWaitlistModal = S.closeWizardWaitlistModal;
      clonePlainMap = S.clonePlainMap;
      peekVenueSession = S.peekVenueSession;
      stashVenueSession = S.stashVenueSession;
      applySavedVenueSession = S.applySavedVenueSession;
      clearVenueSelection = S.clearVenueSelection;
      onVenueResetEvent = S.onVenueResetEvent;
      selectVenueCard = S.selectVenueCard;
      bindVenueSelection = S.bindVenueSelection;
      goToNextFromVenue = S.goToNextFromVenue;
    }

    /* datetime: workshop-booking-wizard-flow-datetime.js */
    var isCalTimeDdOpen = function () {};
    var softRefreshDatetimeDayButtons = function () {};
    var syncCalTimeDdButtonLabel = function () {};
    var softRefreshDatetimeTimeUi = function () {};
    var applySlotToDatetimeStep = function () {};
    var setDatetimeCalLoading = function () {};
    var prefetchVenueCalendar = function () {};
    var paintSlotsOntoCalendar = function () {};
    var resetDatetimeControlsDom = function () {};
    var slotsForDate = function () {};
    var applyDatetimeSelectionAfterSlots = function () {};
    var renderCalendar = function () {};
    var closeCalTimeDd = function () {};
    var findSlotForTimeValue = function () {};
    var bindCalTimeControls = function () {};
    var shiftCalendarMonth = function () {};
    var bindCalMonthSwipe = function () {};
    var syncWorkshopSelection = function () {};
    var startDatetimeStep = function () {};
    var startPopupBookingStep = function () {};
    var popupDateSelect = function () {};
    var popupTimeSelect = function () {};
    var setPopupDatetimeHint = function () {};
    var setPopupDatetimeLoading = function () {};
    var uniquePopupDateKeys = function () {};
    var syncPopupDatetimePanel = function () {};
    var syncPopupSelectFilled = function () {};
    var closePrettySelects = function () {};
    var syncPrettySelect = function () {};
    var enhancePopupSelect = function () {};
    var fillDateSelectOptions = function () {};
    var fillPopupTimeSelect = function () {};
    var applyPopupLiveRefresh = function () {};
    var hydrateVariantsDatetimeControls = function () {};
    var refreshPopupDatetimeControls = function () {};
    var bindPopupDatetimeControls = function () {};
    if (!global.WorkshopBookingWizardFlowDatetime || typeof global.WorkshopBookingWizardFlowDatetime.attach !== 'function') {
      console.error('[WBW] workshop-booking-wizard-flow-datetime.js missing');
    } else {
      S.applySavedVenueSession = applySavedVenueSession;
      S.bookingRoot = bookingRoot;
      S.clearBookingUrlEventIdKeepVariant = clearBookingUrlEventIdKeepVariant;
      S.clonePlainMap = clonePlainMap;
      S.data = data;
      S.ensureLivePoll = ensureLivePoll;
      S.ensureLockedVariantFromUrlOrSlot = ensureLockedVariantFromUrlOrSlot;
      S.isAddonVariantId = isAddonVariantId;
      S.liveController = liveController;
      S.liveFlags = liveFlags;
      S.peekVenueSession = peekVenueSession;
      S.quietEnrichCurrentSlots = quietEnrichCurrentSlots;
      S.rebindSelectedVenueCard = rebindSelectedVenueCard;
      S.refreshLiveNow = refreshLiveNow;
      S.sectionId = sectionId;
      S.setBranch = setBranch;
      S.state = state;
      S.stepEl = stepEl;
      S.sweepViewMonthLive = sweepViewMonthLive;
      S.syncBookingUrlForDatetimeStep = syncBookingUrlForDatetimeStep;
      S.syncBookingUrlForVenueStep = syncBookingUrlForVenueStep;
      S.syncSelectedVenueEventsFromSlots = syncSelectedVenueEventsFromSlots;
      S.syncSiblingWorkshopPromo = syncSiblingWorkshopPromo;
      S.syncVenueKindAttr = syncVenueKindAttr;
      S.updateBranchTitles = updateBranchTitles;
      global.WorkshopBookingWizardFlowDatetime.attach(S);
      isCalTimeDdOpen = S.isCalTimeDdOpen;
      softRefreshDatetimeDayButtons = S.softRefreshDatetimeDayButtons;
      syncCalTimeDdButtonLabel = S.syncCalTimeDdButtonLabel;
      softRefreshDatetimeTimeUi = S.softRefreshDatetimeTimeUi;
      applySlotToDatetimeStep = S.applySlotToDatetimeStep;
      setDatetimeCalLoading = S.setDatetimeCalLoading;
      prefetchVenueCalendar = S.prefetchVenueCalendar;
      paintSlotsOntoCalendar = S.paintSlotsOntoCalendar;
      resetDatetimeControlsDom = S.resetDatetimeControlsDom;
      slotsForDate = S.slotsForDate;
      applyDatetimeSelectionAfterSlots = S.applyDatetimeSelectionAfterSlots;
      renderCalendar = S.renderCalendar;
      closeCalTimeDd = S.closeCalTimeDd;
      findSlotForTimeValue = S.findSlotForTimeValue;
      bindCalTimeControls = S.bindCalTimeControls;
      shiftCalendarMonth = S.shiftCalendarMonth;
      bindCalMonthSwipe = S.bindCalMonthSwipe;
      syncWorkshopSelection = S.syncWorkshopSelection;
      startDatetimeStep = S.startDatetimeStep;
      startPopupBookingStep = S.startPopupBookingStep;
      popupDateSelect = S.popupDateSelect;
      popupTimeSelect = S.popupTimeSelect;
      setPopupDatetimeHint = S.setPopupDatetimeHint;
      setPopupDatetimeLoading = S.setPopupDatetimeLoading;
      uniquePopupDateKeys = S.uniquePopupDateKeys;
      syncPopupDatetimePanel = S.syncPopupDatetimePanel;
      syncPopupSelectFilled = S.syncPopupSelectFilled;
      closePrettySelects = S.closePrettySelects;
      syncPrettySelect = S.syncPrettySelect;
      enhancePopupSelect = S.enhancePopupSelect;
      fillDateSelectOptions = S.fillDateSelectOptions;
      fillPopupTimeSelect = S.fillPopupTimeSelect;
      applyPopupLiveRefresh = S.applyPopupLiveRefresh;
      hydrateVariantsDatetimeControls = S.hydrateVariantsDatetimeControls;
      refreshPopupDatetimeControls = S.refreshPopupDatetimeControls;
      bindPopupDatetimeControls = S.bindPopupDatetimeControls;
    }

    /* variants: workshop-booking-wizard-flow-variants.js */
    var addToCart = function () {};
    var clearWizardNotice = function () {};
    var findSlotBySyncKey = function () {};
    var maxBookableQty = function () {};
    var previewWizardVariant = function () {};
    var refreshOpenLightboxWhen = function () {};
    var refreshVariantRowUI = function () {};
    var renderVariants = function () {};
    var showWizardNotice = function () {};
    var slotSyncKey = function () {};
    var stampFocusedVariantWhenFromMain = function () {};
    var submitWaitlist = function () {};
    var syncAtcReminder = function () {};
    var syncCapacityRing = function () {};
    var updateVariantStepUi = function () {};
    if (!global.WorkshopBookingWizardFlowVariants || typeof global.WorkshopBookingWizardFlowVariants.attach !== 'function') {
      console.error('[WBW] workshop-booking-wizard-flow-variants.js missing');
    } else {
      S.addonVariantIdKey = addonVariantIdKey;
      S.addonVariantObject = addonVariantObject;
      S.bookingRoot = bookingRoot;
      S.closePrettySelects = closePrettySelects;
      S.closeWizardWaitlistModal = closeWizardWaitlistModal;
      S.data = data;
      S.enhancePopupSelect = enhancePopupSelect;
      S.fillDateSelectOptions = fillDateSelectOptions;
      S.fillPopupTimeSelect = fillPopupTimeSelect;
      S.findSlotForTimeValue = findSlotForTimeValue;
      S.isAddonVariantId = isAddonVariantId;
      S.liveController = liveController;
      S.liveFlags = liveFlags;
      S.popupDateSelect = popupDateSelect;
      S.popupTimeSelect = popupTimeSelect;
      S.resolveVariantPriceCents = resolveVariantPriceCents;
      S.sectionId = sectionId;
      S.setPopupDatetimeHint = setPopupDatetimeHint;
      S.slotsForDate = slotsForDate;
      S.state = state;
      S.stepEl = stepEl;
      S.sweepViewMonthLive = sweepViewMonthLive;
      S.syncBookingUrlVariantOnStep3 = syncBookingUrlVariantOnStep3;
      S.syncPopupSelectFilled = syncPopupSelectFilled;
      S.syncPrettySelect = syncPrettySelect;
      S.syncSiblingWorkshopPromo = syncSiblingWorkshopPromo;
      S.uniquePopupDateKeys = uniquePopupDateKeys;
      S.variants = variants;
      global.WorkshopBookingWizardFlowVariants.attach(S);
      addToCart = S.addToCart;
      clearWizardNotice = S.clearWizardNotice;
      findSlotBySyncKey = S.findSlotBySyncKey;
      maxBookableQty = S.maxBookableQty;
      previewWizardVariant = S.previewWizardVariant;
      refreshOpenLightboxWhen = S.refreshOpenLightboxWhen;
      refreshVariantRowUI = S.refreshVariantRowUI;
      renderVariants = S.renderVariants;
      showWizardNotice = S.showWizardNotice;
      slotSyncKey = S.slotSyncKey;
      stampFocusedVariantWhenFromMain = S.stampFocusedVariantWhenFromMain;
      submitWaitlist = S.submitWaitlist;
      syncAtcReminder = S.syncAtcReminder;
      syncCapacityRing = S.syncCapacityRing;
      updateVariantStepUi = S.updateVariantStepUi;
    }

    wizardRoot.addEventListener('click', function (e) {
      var act = e.target.closest('[data-wbw-action]');
      if (act) {
        var action = act.getAttribute('data-wbw-action');
        if (action === 'to-next') {
          e.preventDefault();
          goToNextFromVenue();
          return;
        }
        if (action === 'to-variants') {
          e.preventDefault();
          if (!state.selectedSlot || !slotBookable(state.selectedSlot)) return;
          refreshLiveNow({ force: true });
          closeCalTimeDd();
          ensureLockedVariantFromUrlOrSlot();
          window.__WB_LOCK_VARIANT_URL__ = true;
          if (state.lockedVariantId) state.focusedVariantId = vQtyKey(state.lockedVariantId);
          setBranch('variants');
          hydrateVariantsDatetimeControls();
          renderVariants();
          return;
        }
        if (action === 'back') {
          e.preventDefault();
          if (state.branch === 'variants') {
            if (state.selectedVenue && !isStoreVenue(state.selectedVenue)) {
              state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
              setPopupDatetimeLoading(false);
              stashVenueSession(state.selectedVenue);
              clearVenueSelection();
              setBranch('venue');
              return;
            }
            if (state.selectedSlot) syncBookingUrlForDatetimeStep(state.selectedSlot);
            else clearBookingUrlEventIdKeepVariant();
            setBranch('datetime');
            renderCalendar({ closeTimeDd: false, allowAutoSelectSingle: false });
          } else if (state.branch === 'datetime' || state.branch === 'waitlist') {
            /* Invalidate in-flight calendar → Step 2 must not reappear after Back. */
            state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
            setDatetimeCalLoading(false);
            stashVenueSession(state.selectedVenue);
            clearVenueSelection();
            setBranch('venue');
          }
          return;
        }
        if (action === 'clear-selection') {
          e.preventDefault();
          state.variantQty = {};
          renderVariants();
          return;
        }
        if (action === 'add-cart') {
          e.preventDefault();
          addToCart();
          return;
        }
        if (action === 'wl-submit') {
          e.preventDefault();
          submitWaitlist();
          return;
        }
      }

      var dateBtn = e.target.closest('[data-wbw-date-btn]');
      if (dateBtn && stepEl('datetime') && stepEl('datetime').contains(dateBtn)) {
        e.preventDefault();
        var avail = Object.keys(state.daysWithEvents || {}).sort();
        if (!state.selectedDate && avail.length) {
          state._wbwUserPickedCalDate = true;
          state.selectedDate = avail[0];
          var dp = avail[0].split('-').map(Number);
          if (dp.length >= 2) state.viewMonth = new Date(dp[0], dp[1] - 1, 1);
          state.selectedSlot = null;
          var apiDateBtn = wbwAnalytics();
          try {
            if (apiDateBtn && typeof apiDateBtn.trackUser === 'function') {
              apiDateBtn.trackUser('date', 'wbw_date_select', state, wizardRoot, data, {
                wbw_date: state.selectedDate,
                wbw_source: 'date_btn',
              });
            } else {
              if (apiDateBtn && typeof apiDateBtn.mark === 'function') apiDateBtn.mark('date');
              wbwTrack('wbw_date_select', { wbw_date: state.selectedDate, wbw_source: 'date_btn' });
            }
          } catch (_) {}
          renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: true });
          refreshLiveNow({ force: true });
        } else if (!avail.length) {
          dateBtn.textContent = 'Select a date';
        }
        return;
      }

      var calDay = e.target.closest('[data-wbw-cal-day]');
      if (
        calDay &&
        !calDay.disabled &&
        !calDay.classList.contains('wcf-cal-day--empty') &&
        calDay.classList.contains('wcf-cal-day--has-event') &&
        stepEl('datetime') &&
        stepEl('datetime').contains(calDay) &&
        !(state._wbwIgnoreCalTapUntil && Date.now() < state._wbwIgnoreCalTapUntil)
      ) {
        state._wbwUserPickedCalDate = true;
        state.selectedDate = calDay.getAttribute('data-wbw-cal-day') || '';
        state.selectedSlot = null;
        clearBookingUrlEventIdKeepVariant();
        var apiCal = wbwAnalytics();
        try {
          if (apiCal && typeof apiCal.trackUser === 'function') {
            apiCal.trackUser('date', 'wbw_date_select', state, wizardRoot, data, {
              wbw_date: state.selectedDate,
              wbw_source: 'calendar',
            });
          } else {
            if (apiCal && typeof apiCal.mark === 'function') apiCal.mark('date');
            wbwTrack('wbw_date_select', { wbw_date: state.selectedDate, wbw_source: 'calendar' });
          }
        } catch (_) {}
        renderCalendar({ closeTimeDd: true, allowAutoSelectSingle: true });
        refreshLiveNow({ force: true });
        return;
      }

      if (e.target.closest('[data-wbw-cal-prev]')) {
        if (state._wbwIgnoreCalTapUntil && Date.now() < state._wbwIgnoreCalTapUntil) return;
        shiftCalendarMonth(-1);
        return;
      }
      if (e.target.closest('[data-wbw-cal-next]')) {
        if (state._wbwIgnoreCalTapUntil && Date.now() < state._wbwIgnoreCalTapUntil) return;
        shiftCalendarMonth(1);
        return;
      }

    });

    window.addEventListener(
      'resize',
      function () {
        var wrap = wizardRoot.querySelector('[data-wbw-variants]');
        if (wrap && wrap.querySelectorAll('.wcf-variant-row').length) {
          applyVariantGridLayout(wrap, wrap.querySelectorAll('.wcf-variant-row').length, wizardRoot);
        }
      },
      { passive: true }
    );

    bindVenueSelection();
    (function bootAnalytics() {
      var api = wbwAnalytics();
      if (!api) return;
      if (typeof api.wizardViewOnce === 'function') api.wizardViewOnce(state, wizardRoot, data);
      if (typeof api.armAbandon === 'function') {
        api.armAbandon(function () {
          return {
            wbw_branch: state.branch,
            wbw_flow: state.flow,
            wbw_product_id: String(data.productId || wizardRoot.getAttribute('data-product-id') || ''),
            wbw_product_handle: String(
              data.productHandle || wizardRoot.getAttribute('data-product-handle') || ''
            ),
            wbw_venue_id: state.selectedVenue
              ? String(state.selectedVenue.venue_ref_id || state.selectedVenue.venue_id || '')
              : '',
            wbw_date: String(state.selectedDate || ''),
            wbw_page_url: window.location.href,
          };
        });
      }
    })();
    document.addEventListener('wbw:venue-reset', onVenueResetEvent);
    document.addEventListener('wbw:venue-list-rendered', function () {
      rebindSelectedVenueCard();
      updateVenueContinue();
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) return;
      if (state.branch !== 'venue') return;
      var locSource =
        (typeof window !== 'undefined' &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source) ||
        '';
      if (
        locSource === 'places' ||
        locSource === 'places_autocomplete' ||
        locSource === 'geocode_search'
      ) {
        return;
      }
      tryApplyWizardUrlDeepLink();
      if (
        document.documentElement.getAttribute('data-wbw-deeplink') === '1' &&
        !wizardRoot.__wbwUrlDeepLinkComplete
      ) {
        try {
          document.documentElement.removeAttribute('data-wbw-deeplink');
        } catch (_) {}
        setBranch('venue');
      }
    });
    window.setTimeout(function () {
      tryApplyWizardUrlDeepLink();
    }, 0);
    bindCalTimeControls();
    bindCalMonthSwipe();
    bindPopupDatetimeControls();
    if (bookingRoot) {
      bindWizardSearchLayout(bookingRoot);
    }
    wizardRoot.setAttribute('data-wbw-flow', 'booking');
    if (!urlHasWizardDeepLink()) {
      try {
        document.documentElement.removeAttribute('data-wbw-deeplink');
      } catch (_) {}
      setBranch('venue');
    }
    updateVenueContinue();
    updateProgressLabels();
    }
  };
})(typeof window !== "undefined" ? window : this);
